module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/173-mali-46d394edcd43cd26c91f52db491277e0.svg";